import React from 'react';
import { FieldState } from 'formstate';
import { observer } from 'mobx-react';
import { ApplicantForm } from '../../forms/application-information-forms';
import { Applicant } from './applicant';
import { Address } from './address';
interface IPrimaryApplicantProps {
    applicant: ApplicantForm;
    states: string[];
    validate: (fieldState: FieldState<string>) => () => Promise<void>;
}

export const PrimaryApplicant: React.FC<IPrimaryApplicantProps> = observer(
    ({ applicant, states, validate }) => {
        const {
            $: { PersonalInfo: personalInfo, Document: document, HomeAddress: homeAddress },
        } = applicant;

        return (
            <React.Fragment>
                <Applicant
                    personalInfo={personalInfo}
                    document={document}
                    states={states}
                    validate={validate}
                />
                <Address
                    address={homeAddress}
                    disabled={false}
                    states={states}
                    validate={validate}
                />
            </React.Fragment>
        );
    }
);
